import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your actual Firebase Web Config from the Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyBCHQAPmsAzOAFX8JIgRCxI8pz82mH5pug",
  authDomain: "bentobox-c43f2.firebaseapp.com",
  projectId: "bentobox-c43f2",
  storageBucket: "bentobox-c43f2.firebasestorage.app",
  messagingSenderId: "368516652487",
  appId: "1:368516652487:web:cf6896e3116014340a8de2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
